const CartIcon = ({ fromPDP, ...props }) => {
  if (fromPDP) {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={18}
        height={18}
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
        className='lucide lucide-shopping-cart'
        {...props}
      >
        <circle cx={8} cy={21} r={1} />
        <circle cx={19} cy={21} r={1} />
        <path d='M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12' />
      </svg>
    );
  } else {
    return (
      <svg viewBox='0 0 24 24' className='h-[22px] w-[22px]' aria-hidden>
        <path
          d='M3 4h2l2.5 12h11L21 7H6'
          fill='none'
          stroke='currentColor'
          strokeWidth='1.6'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <circle cx='10' cy='20' r='1.6' fill='currentColor' />
        <circle cx='17' cy='20' r='1.6' fill='currentColor' />
      </svg>
    );
  }
};
export default CartIcon;
